import {useQuery} from "react-query";
import ShipmentMilestonesApi from "./Shipment.Milestones.api";

export function useShipmentOperationsMilestones(query:any){
    return useQuery(["fetchShipmentOperationsMilestones", query], ShipmentMilestonesApi.getShipmentOperationsMilestones);
}

export function useShipmentLogisticsMilestones(query:any){
    return useQuery(["fetchShipmentLogisticsMilestones", query], ShipmentMilestonesApi.getShipmentLogisticsMilestones);
}